export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/cashmanage_icon_enquiry@2x.png";